import * as React from 'react';
import { TabContent, TabPane } from 'reactstrap';
import { MatchRoundAccuracyStatsCategories } from '../../../../../helpers';
import { IMatchFinalBoxScoreDto } from '../../../../../WorldDoomLeague';
import MatchOverallWeaponsAccuracyTable from './MatchOverallWeaponsAccuracyTable';

interface MatchRoundWeaponCategoryAccuracyTabsViewProps {
    categoryObject: MatchRoundAccuracyStatsCategories;
    activeWeapon: string;
    finalBoxScore: IMatchFinalBoxScoreDto;
};

const MatchOverallWeaponCategoryAccuracyTabsView = (props: MatchRoundWeaponCategoryAccuracyTabsViewProps) => {

    return (
        <React.Fragment>
            <TabContent activeTab={props.activeWeapon}>
                {props.categoryObject && props.categoryObject.AccuracyWeaponCategories.map((s, idx) => (
                    <TabPane tabId={s} key={idx}>
                        <MatchOverallWeaponsAccuracyTable activeWeapon={props.activeWeapon} categoryObject={props.categoryObject} finalBoxScore={props.finalBoxScore} />
                    </TabPane>
                    ))}
            </TabContent>
        </React.Fragment>);
};

export default MatchOverallWeaponCategoryAccuracyTabsView;